export enum YesNo {
  Yes = 'Có',
  No = 'Không'
}